import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-89">
      <div className="max-w-6xl mx-auto px-4" data-id="element-90">
        <div className="grid md:grid-cols-3 gap-8 mb-8 border-b border-gray-800 pb-8" data-id="element-91">
          <div data-id="element-92">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-93">
              Pago Seguro
            </h4>
            <div className="flex items-center space-x-2 mb-2" data-id="element-94">
              <Lock className="w-4 h-4 text-green-500" data-id="element-95" />
              <span data-id="element-96">Checkout encriptado 256-bit</span>
            </div>
            <div className="flex items-center space-x-2 mb-2" data-id="element-97">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-98" />
              <span data-id="element-99">Garantía de 45 días</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-100">
              <CreditCard className="w-4 h-4 text-green-500" data-id="element-101" />
              <span data-id="element-102">Múltiples métodos de pago</span>
            </div>
          </div>

          <div data-id="element-103">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-104">
              Links Útiles
            </h4>
            <ul className="space-y-2" data-id="element-105">
              <li data-id="element-106">
                <a href="#" className="hover:text-white transition-colors" data-id="element-107">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-white transition-colors" data-id="element-109">
                  Políticas de Privacidad
                </a>
              </li>
              <li data-id="element-110">
                <a href="#" className="hover:text-white transition-colors" data-id="element-111">
                  Políticas de Reembolso
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-112">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-113">
              Contacto
            </h4>
            <p className="mb-2" data-id="element-114">¿Tenés alguna duda?</p>
            <a href="mailto:soporte@ejemplo.com" className="text-blue-400 hover:text-blue-300 transition-colors" data-id="element-115">
              soporte@ejemplo.com
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-gray-500 space-y-4" data-id="element-116">
          <p data-id="element-117">
            &copy; {new Date().getFullYear()} Mega-Pack Gimnasia Artística.
            Todos los derechos reservados.
          </p>
          <p className="max-w-4xl mx-auto" data-id="element-118">
            DESCARGO DE RESPONSABILIDAD: Este sitio no es parte del sitio web de
            Facebook o Facebook Inc. Además, este sitio NO está respaldado por
            Facebook de ninguna manera. FACEBOOK es una marca registrada de
            FACEBOOK, Inc. Los resultados mencionados son testimonios de
            clientes reales, pero no garantizan resultados idénticos, ya que
            dependen del esfuerzo y dedicación de cada individuo.
          </p>
        </div>
      </div>
    </footer>;
};